window.addEventListener('DOMContentLoaded', loadProductSwatches())

function loadProductSwatches() {

  // On a translated storefront every storefront path is prefixed with the locale root
  // (e.g. /fr-ca/). Fetching without it returns default-locale copy.
  function localeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  }

  // Load Frenzy Bundle on Quick View
  if (document.getElementById('Product-Drawer-Content')) {
    const frenzyProductId = document.querySelector('input[name="product-id"]')?.value.trim();
    const frenzyVariantId = document.querySelector('input[name="id"]')?.value.trim();
    product_id_Frenzy = frenzyProductId
    variant_id_Frenzy = frenzyVariantId
    if (product_id_Frenzy && variant_id_Frenzy) {
      frenzy_sku = `${product_id_Frenzy}_${variant_id_Frenzy}`
    }
    
    frenzyScriptReload()
    if (document.querySelector('.frenzy_bundle_id')) {
      $frenzy_bundle_event()
    }
  }

  // The product the swap last put on screen. The main pdp-variant-selects keeps the
  // variants JSON the page loaded with, so after a sibling swap this cache - not the
  // inlined JSON - is the truth about the variants currently purchasable.
  let currentProductData = null

  const colorFieldset = document.querySelector('fieldset[data-colorswatches="true"]')
  const sizeFieldset = findSizeFieldset(document);
  const dominationFieldset = document.querySelector('fieldset[data-handle="denominations"]')
  let sizeSwatches = sizeFieldset ? sizeFieldset.querySelectorAll('input[type="radio"]') : null;
  let isSolidColor = false
  let isPrintColor = false

  if(dominationFieldset) {
    dominationFieldset.addEventListener('change', (e) => {
      if (e.target.tagName === 'INPUT') {
        const productHandle = e.target.dataset.productHandle
  
  
        // Fetch the product data
        fetch(`${localeRoot()}products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }
          return response.json(); // Return the response as JSON
        })
        .then(productData => {

          currentProductData = productData
          const value = e.target.value
          dispatchCustomEvent("product:variant-changed", {
            productData: productData
          })
  
          updateProductMedia(productData)
          updateProductInfoDominations(productData, value)
          updateProductAddToCartForm(productData, value)  
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
      }
    })
  }

  if(sizeSwatches && sizeSwatches.length > 0) {
  // Get DOMContentLoaded selected Size Swatch Value and Index - Store it Locally
  sizeSwatches.forEach((sizeSwatch, index) => {
    if (sizeSwatch.checked) {
      localStorage.setItem('sizeSwatchValue', sizeSwatch.value)
      localStorage.setItem('sizeSwatchIndex', index)
    }
  })
  }
  

  if(colorFieldset) {
    colorFieldset.addEventListener('change', (e) => {
      if (e.target.tagName === 'INPUT') {
        const productHandle = e.target.dataset.productHandle
        const storedSizeValue = localStorage.getItem('sizeSwatchValue')
        const storedSizeIndex = localStorage.getItem('sizeSwatchIndex')
  
        // Check which type of color swatch was selected
        if (e.target.parentNode.classList.contains('solid_swatches')) {
          isSolidColor = true
        } else {
          isSolidColor = false
        }
        if (e.target.parentNode.classList.contains('print_swatches')) {
          isPrintColor = true
        } else {
          isPrintColor = false
        }
  
  
        // Fetch the product data
        fetch(`${localeRoot()}products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }
          return response.json(); // Return the response as JSON
        })
        .then(productData => {

          // ECSR-982: the sold-out reload guard was removed here on purpose - the
          // theme renders its own Notify Me button, so an out of stock
          // destination no longer needs a fresh page load to get one. Do not
          // reinstate the window.location.replace block; every colour swap is
          // the same in place AJAX swap.
          currentProductData = productData
          const matchingVariant = resolveVariantForSize(productData, storedSizeValue)

          dispatchCustomEvent("product:variant-changed", {
            productData: productData
          })

          updateProductMedia(productData)
          // Pass the size the destination color actually stocks, so the main area and
          // the sticky bar both describe the one variant resolved above.
          const resolvedSizeValue = matchingVariant.option2
          updateProductInfo(productData, resolvedSizeValue, storedSizeIndex, isSolidColor, isPrintColor)
          updateProductAddToCartForm(productData, resolvedSizeValue)

        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
          window.location.replace(`${localeRoot()}products/${productHandle}`)
        });
      }
    })
  }
 

  // The sticky add to cart bar renders its own copy of the size options. It is bound
  // to the same product form, so a size picked there has to run through exactly the
  // same update path as one picked in the main buy area.
  const stickyBar = document.querySelector('product-add-to-cart-sticky')
  const stickySizeFieldset = stickyBar ? findSizeFieldset(stickyBar) : null

  if(sizeFieldset) {
    sizeFieldset.addEventListener('change', handleSizeSwatchChange)
  }

  if(stickySizeFieldset) {
    stickySizeFieldset.addEventListener('change', handleSizeSwatchChange)
  }

  function handleSizeSwatchChange(e) {
      if (e.target.tagName === 'INPUT') {
        const productHandle = e.target.dataset.productHandle
        const sizeIndex = e.target.dataset.index
        const value = e.target.value

        // Handle ATC error messages
        const errorForm = document.querySelector('.product-form__error-message-wrapper')
        if (!errorForm.getAttribute('hidden')) {
          errorForm.setAttribute('hidden', '')
        }

        // An explicit size click is the only thing that may rewrite the shopper's
        // remembered size preference.
        localStorage.setItem('sizeSwatchValue', value)
        localStorage.setItem('sizeSwatchIndex', sizeIndex)

        // Point the form at the picked size before the fetch. A shopper who taps a size
        // in the sticky bar and adds to cart straight away would otherwise submit the
        // variant the page was showing beforehand. The fetch below only refreshes
        // price, media, estimate and accordions.
        setSubmittedVariantForSize(knownVariantsForHandle(productHandle), value)

        // Fetch the product data
        fetch(`${localeRoot()}products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }
          return response.json(); // Return the response as JSON
        })
        .then(productData => {

          currentProductData = productData
          dispatchCustomEvent("product:variant-changed", {
            productData: productData
          })

          updateProductInfo(productData, value, sizeIndex, isSolidColor, isPrintColor)
          updateProductAddToCartForm(productData, value)

        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
      }
  }

  // Begin Functions -------------------------------------------------------------

  // One place that answers "which variant is this product showing?" - a size that the
  // destination color does not stock falls through to the first available variant.
  function resolveVariantForSize(productData, sizeValue) {
    if (!productData || !productData.variants) return null
    return productData.variants.find(variant => variant.option2 === sizeValue)
      || productData.variants.find(variant => variant.available)
      || productData.variants[0]
      || null
  }

  // The variants of the product on screen, without a round trip: the cache the last
  // swap left behind, or - before any swap has run - the variants JSON the page
  // inlined next to the main picker. Returns null when neither is trustworthy.
  function knownVariantsForHandle(productHandle) {
    if (currentProductData) {
      return currentProductData.handle === productHandle ? currentProductData.variants : null
    }
    const inlineVariants = document.querySelector('pdp-variant-selects script[type="application/json"]')
    if (!inlineVariants) return null
    try {
      const variants = JSON.parse(inlineVariants.textContent)
      return Array.isArray(variants) && variants.length ? variants : null
    } catch (error) {
      console.error('There was a problem reading the inlined variants:', error)
      return null
    }
  }

  // Write the variant the shopper just picked into the form that add to cart submits,
  // using the same fallback rule the rest of the swap uses. No-op when the page holds
  // no trustworthy variant data, leaving the fetch to set it as before.
  function setSubmittedVariantForSize(variants, sizeValue) {
    if (!variants) return
    const matchingVariant = resolveVariantForSize({ variants: variants }, sizeValue)
    if (!matchingVariant) return
    const productSlider = document.getElementById('Product-Slider')
    if (!productSlider) return
    const form = document.getElementById(`product-form-${productSlider.getAttribute('data-section-id')}`)
    const variantInput = form && form.querySelector('input[name="id"]')
    if (!variantInput) return
    variantInput.value = matchingVariant.id
  }

  function resolveSizeIndex(productData, sizeValue, fallbackIndex) {
    const values = productData.options && productData.options[1] && productData.options[1].values
    const index = values ? values.indexOf(sizeValue) : -1
    return index === -1 ? fallbackIndex : index
  }

  // Regenerating a fieldset destroys whatever radio the keyboard user was on.
  function withFocusPreserved(fieldset, rebuild) {
    const hadFocus = fieldset.contains(document.activeElement)
    rebuild()
    if (!hadFocus) return
    const focusTarget = fieldset.querySelector('input[type="radio"]:checked')
      || fieldset.querySelector('input[type="radio"]')
    if (focusTarget) {
      focusTarget.focus()
    }
  }

  function buildCompletePriceMarkup(productData, matchingVariant, sectionId) {
    const originalPrice = matchingVariant.price;
    let price = matchingVariant.price;
    let compareAtPrice = matchingVariant.compare_at_price;
    const available = matchingVariant.available;
    let discountedClass = '';
    let xforyPrice = null;
    let finalPrice = price;
    let saleOnlinePercent = null;
    
    const saleOnlineTag = productData.tags.find(tag => tag.includes('sale-online-') && !tag.includes('pos'));
    if (saleOnlineTag) {
      saleOnlinePercent = parseInt(saleOnlineTag.replace('sale-online-', ''));
    }

    const hasXforyTag = productData.tags.some(tag => tag.includes('online-sale-xfory-') || tag.includes('sale-xfory-'));
    let hasXforyDiscount = false;
    
    if (hasXforyTag) {
      for (const tag of productData.tags) {
        if (tag.includes('sale-xfory-') && !tag.includes('pos-sale-xfory-')) {
          const cleanTag = tag.replace('online-sale-xfory-', '').replace('sale-xfory-', '');
          const tokens = cleanTag.split('-');
          const tagQty = parseInt(tokens[0]);
          const newPrice = parseInt(tokens[tokens.length - 1]);
          
          if (tagQty === 1) {
            compareAtPrice = originalPrice;
            xforyPrice = newPrice;
            price = newPrice;
            hasXforyDiscount = true;
            break;
          }
        }
      }
    }
    
    if (saleOnlinePercent) {
      if (!hasXforyDiscount) {
        compareAtPrice = price;
      }
      
      const priceOff = price * (saleOnlinePercent / 100);
      finalPrice = price - priceOff;
    } else {
      finalPrice = price;
    }
    const compareAtPriceFormatted = compareAtPrice ? window.formatMoney(compareAtPrice, window.theme.settings.money_with_currency_format) : null;
    const xforyPriceFormatted = xforyPrice ? window.formatMoney(xforyPrice, window.theme.settings.money_with_currency_format) : null;
    const finalPriceFormatted = window.formatMoney(finalPrice, window.theme.settings.money_with_currency_format);
    const hasNestedDiscounts = hasXforyDiscount && saleOnlinePercent;
    const showComparePrice = hasXforyDiscount || saleOnlinePercent || (compareAtPrice && compareAtPrice !== finalPrice);
    let priceContentHTML = '';
    
    if (showComparePrice && compareAtPriceFormatted) {
      const strikethrough = hasXforyDiscount || saleOnlinePercent ? 'style="text-decoration: line-through;"' : '';
      const tag = hasXforyDiscount || saleOnlinePercent ? 'ins' : 'del';
      priceContentHTML += `
        <${tag}>
          <span class="amount" ${strikethrough} style="display: block; margin-left: 10px;">${compareAtPriceFormatted}</span>
        </${tag}>
      `;
    }
    
    if (!hasNestedDiscounts) {
      let displayPriceHTML = '';

      if (saleOnlinePercent) {
        displayPriceHTML = `<ins><span class="amount sale-price" style="display: block; margin-left: 10px;">${finalPriceFormatted}</span></ins>`;
      } else if (hasXforyDiscount) {
        displayPriceHTML = `<ins><span class="amount" style="display: block; margin-left: 10px;">${xforyPriceFormatted}</span></ins>`;
      } else {
        displayPriceHTML = `<ins><span class="amount" style="display: block;">${finalPriceFormatted}</span></ins>`;
      }

      priceContentHTML += displayPriceHTML;
    }
    
    if (hasXforyDiscount) {
      productData.tags.forEach(tag => {
        if (tag.includes('sale-xfory-') && !tag.includes('pos-sale-xfory-')) {
          const cleanTag = tag.replace('online-sale-xfory-', '').replace('sale-xfory-', '');
          const tokens = cleanTag.split('-');
          const xforyValue = parseInt(tokens[tokens.length - 1]);
          const formattedXfory = window.formatMoney(xforyValue, window.theme.settings.money_with_currency_format);
          const displayStyle = saleOnlinePercent 
            ? 'display: block; margin-left: 10px; text-decoration: line-through;' 
            : 'display: none';
          
          priceContentHTML += `
            <ins>
              <span class="amount sale-price xfory-price" style="${displayStyle}">${formattedXfory}</span>
            </ins>
          `;
        }
      });
    }
    
    let unitPriceHTML = '';
    if (matchingVariant.unit_price_measurement) {
      const unitPrice = window.formatMoney(matchingVariant.unit_price, window.theme.settings.money_with_currency_format);
      const referenceValue = matchingVariant.unit_price_measurement.reference_value !== 1 ? matchingVariant.unit_price_measurement.reference_value : '';
      const referenceUnit = matchingVariant.unit_price_measurement.reference_unit;
      
      unitPriceHTML = `
        <small class="unit-price">
          <span>${unitPrice}</span>
          <span class="unit-price-separator">/</span>
          <span>${referenceValue}${referenceUnit}</span>
        </small>
      `;
    } else {
      unitPriceHTML = `
        <small class="unit-price hidden">
          <span></span>
          <span class="unit-price-separator">/</span>
          <span> </span>
        </small>
      `;
    }
    
    let badgesHTML = '';
    const saleBadgeType = window.theme.settings?.sale_badge_type || 'save_percentage';
    
    if (saleOnlinePercent) {
      if (saleBadgeType === 'save_amount') {
        const basePrice = hasXforyDiscount ? xforyPrice : originalPrice;
        const savedAmount = basePrice - finalPrice;
        const savedAmountFormatted = window.formatMoney(savedAmount, window.theme.settings.money_with_currency_format);
        badgesHTML += `<span class="badge onsale">Save ${savedAmountFormatted}</span>`;
      } else if (saleBadgeType === 'save_percentage') {
        badgesHTML += `<span class="badge onsale">Save ${saleOnlinePercent}%</span>`;
      } else {
        badgesHTML += `<span class="badge onsale">On Sale</span>`;
      }
    }
    
    const badgeComparePrice = hasXforyDiscount ? originalPrice : compareAtPrice;
    const badgePrice = hasXforyDiscount ? xforyPrice : price;
    
    if (badgeComparePrice && badgePrice < badgeComparePrice) {
      const savedAmount = badgeComparePrice - badgePrice;
      const savedPercentage = Math.round((savedAmount * 100.0) / badgeComparePrice);
      
      if (saleBadgeType === 'save_amount') {
        const savedAmountFormatted = window.formatMoney(savedAmount, window.theme.settings.money_with_currency_format);
        badgesHTML += `<span class="badge onsale">Save ${savedAmountFormatted}</span>`;
      } else if (saleBadgeType === 'save_percentage') {
        badgesHTML += `<span class="badge onsale">Save ${savedPercentage}%</span>`;
      } else {
        badgesHTML += `<span class="badge onsale">On Sale</span>`;
      }
    }
    
    if (!available) {
      badgesHTML += `<span class="badge out-of-stock">Sold out</span>`;
    }
    
    const hasPreorder = productData.metafields && productData.metafields.theme && productData.metafields.theme.preorder;
    if (hasPreorder && productData.available) {
      badgesHTML += `<span class="badge pre-order">Pre-order</span>`;
    }
    
    const priceMarkup = `
      <div class="no-js-hidden" id="price-${sectionId}">
        <span class="price">
          ${priceContentHTML}
          ${unitPriceHTML}
          <span class="badges">${badgesHTML}</span>
        </span>
      </div>
    `;
    
    return priceMarkup;
  }

  function updateProductMedia(productData) {
    const mediaSlider = document.getElementById('Product-Slider')
    const sectionId = mediaSlider.getAttribute('data-section-id')

    // Set Active Media
    const flkty = Flickity.data(mediaSlider)
    const firstMediaId = productData.media[0].id
    const newSlides = createNewSlides(productData, sectionId)
      
    if (flkty) {
      mediaSlider.selectCell(firstMediaId);
      // Update Thumbnails
      flkty.remove(flkty.getCellElements());
      flkty.append(newSlides);
      flkty.select( 0, false, true );
      updateThumbnails(productData, sectionId)
      addZoomToImages()
    }

  }

  function updateProductInfoDominations(productData, value) {
    const matchingVariant = productData.variants.find(variant => variant.option1 === value)

    // Update product title
    const title = document.querySelector('.product-title')
    title.innerText = productData.title

    const priceContainer = document.querySelector('.product-price-container')
    const sectionId = document.getElementById('Product-Slider').getAttribute('data-section-id')
    const priceMarkup = buildCompletePriceMarkup(productData, matchingVariant, sectionId)
    priceContainer.innerHTML = priceMarkup


    // Handle inventory level
    const inventoryContainer = document.getElementById(`inventory-${sectionId}`)
    if (matchingVariant.inventory_quantity > 0 && matchingVariant.inventory_quantity <= 5) {
      let scale = matchingVariant.inventory_quantity * 5
      if (scale === 5) {
        scale = `0${scale}`
      }
      const inventoryMarkup = `
        <div class="product-inventory-notice product-inventory-notice--low">
          <div class="product-inventory-notice--text">
            <div class="product-inventory-notice--pulse"></div>
            ${matchingVariant.inventory_quantity} in stock
          </div>
          <div class="product-inventory-notice--bar" style="--inventory-scale:0.${scale}">
            <span></span>
          </div>
        </div>
      `
      if (inventoryContainer) {
        inventoryContainer.innerHTML = ''
        inventoryContainer.innerHTML = inventoryMarkup
      }

    } else {
      if (inventoryContainer) {
        inventoryContainer.innerHTML = ''
      }

    }

    // Update Product Features Accordions (Fit, Materials, etc.)
    updateProductAccordions(productData)
  }

  function updateProductInfo(productData, storedSizeValue, storedSizeIndex, isSolidColor, isPrintColor) {
    // Sibling colors do not all carry the same size run. Resolve the variant with the
    // same fallback chain the color handler uses so that a destination size run that
    // lacks the stored size still lands on a real variant instead of throwing.
    const matchingVariant = resolveVariantForSize(productData, storedSizeValue)
    if (!matchingVariant) return
    // Everything downstream - swatches, sticky bar, stored size - has to describe the
    // variant that was actually resolved, not the size that no longer exists.
    const effectiveSizeValue = matchingVariant.option2
    const effectiveSizeIndex = resolveSizeIndex(productData, effectiveSizeValue, storedSizeIndex)
    // Render-side only. A color that does not stock the shopper's size must not erase
    // the size they asked for - the next color that does stock it has to come back to
    // it - so the remembered preference in localStorage stays as the shopper set it.

    // Update product title
    const title = document.querySelector('.product-title')
    title.innerText = productData.title

    // Update product price with complete logic from product-price.liquid
    const priceContainer = document.querySelector('.product-price-container')
    const sectionId = document.getElementById('Product-Slider').getAttribute('data-section-id')
    
    // Build complete price markup with all logic from product-price.liquid
    const priceMarkup = buildCompletePriceMarkup(productData, matchingVariant, sectionId)
    priceContainer.innerHTML = priceMarkup
    const inventoryContainer = document.getElementById(`inventory-${sectionId}`)
    if (matchingVariant.inventory_quantity > 0 && matchingVariant.inventory_quantity <= 5) {
      let scale = matchingVariant.inventory_quantity * 5
      if (scale === 5) {
        scale = `0${scale}`
      }
      const inventoryMarkup = `
        <div class="product-inventory-notice product-inventory-notice--low">
          <div class="product-inventory-notice--text">
            <div class="product-inventory-notice--pulse"></div>
            ${matchingVariant.inventory_quantity} in stock
          </div>
          <div class="product-inventory-notice--bar" style="--inventory-scale:0.${scale}">
            <span></span>
          </div>
        </div>
      `
      inventoryContainer.innerHTML = ''
      inventoryContainer.innerHTML = inventoryMarkup
    } else {
      inventoryContainer.innerHTML = ''
    }


    // Create new size swatches
    createNewSizeSwatches(productData, effectiveSizeIndex, effectiveSizeValue, effectiveSizeValue)

    // Update ATC Button
    const ATCButton = document.getElementById('AddToCart')

    if (ATCButton && !matchingVariant.available) {
      ATCButton.setAttribute('disabled', 'disabled')
      ATCButton.querySelector('span.single-add-to-cart-button--text').innerText = window.theme.variantStrings.soldOut
    } else if (ATCButton) {
      ATCButton.removeAttribute('disabled')
      ATCButton.querySelector('span.single-add-to-cart-button--text').innerText = window.theme.variantStrings.addToCart
    }

    // Update Option Labels
    const solidContainer = document.querySelector('.solid_swatches')
    const solidOptionLabel = solidContainer?.querySelector('span.form__label__value')
    const printContainer = document.querySelector('.print_swatches')
    const printOptionLabel = printContainer?.querySelector('span.form__label__value')

    if (isSolidColor) {
      if (solidOptionLabel) {
        solidOptionLabel.innerText = ` : ${matchingVariant.option1}`
      }
      if (printOptionLabel) {
        printOptionLabel.innerText = ''
      }
    } else if (isPrintColor) {
      if (solidOptionLabel) {
        solidOptionLabel.innerText = ''
      }
      if (printOptionLabel) {
        printOptionLabel.innerText = ` : ${matchingVariant.option1}`
      }
    }

    // Update FRENZY Bundles
    product_id_Frenzy = productData.id
    variant_id_Frenzy = matchingVariant.id
    if (product_id_Frenzy && variant_id_Frenzy) {
      frenzy_sku = `${product_id_Frenzy}_${variant_id_Frenzy}`
    }
    
    frenzyScriptReload()
    if (document.querySelector('.frenzy_bundle_id')) {
      $frenzy_bundle_event()
    }

    // Update Product Description
    const descriptionContainerDesktop = document.querySelector('.collapsible-content-desktop[data-product-template="true"] .section-description-wrapper')
    const descriptionContainerMobile = document.querySelector('.collapsible-content-mobile[data-product-template="true"] .section-description-wrapper')

    if (descriptionContainerDesktop) {
      descriptionContainerDesktop.innerHTML = ''
      descriptionContainerDesktop.innerHTML = productData.description
    }
    if (descriptionContainerMobile) {
      descriptionContainerMobile.innerHTML = ''
      descriptionContainerMobile.innerHTML = productData.description
    }

    // Update Product Features Accordions (Fit, Materials, etc.)
    // The accordions and the installment estimate both read the destination product's
    // rendered section. When they live in the same section, one render serves both;
    // otherwise each keeps its own fetch.
    const accordionSectionId = findAccordionSectionId()
    const installmentScope = document.getElementById(`shopify-section-${sectionId}`) || document
    const sharedAccordionSectionId = accordionSectionId
      && accordionSectionId === sectionId
      && installmentScope.querySelector('#product-form-installment')
      ? accordionSectionId
      : null

    // Keep the sticky add to cart bar showing the product that is now on screen
    updateStickyAddToCart(productData, effectiveSizeValue, effectiveSizeIndex, sectionId)

    // Keep the installment estimate and its tooltip on the variant now on screen. It
    // only re-renders the section when the estimate can actually change, so when it
    // stands pat the accordions still need their own fetch.
    const estimateFetched = updateInstallmentEstimate(productData, matchingVariant, sectionId, sharedAccordionSectionId)
    if (!sharedAccordionSectionId || !estimateFetched) {
      updateProductAccordions(productData)
    }
  }

  function updateProductAddToCartForm(productData, value) {
    let matchingVariant = productData.variants.find(variant => variant.option2 === value);
    if (!matchingVariant)  {
      matchingVariant = productData.variants.find(variant => variant.option1 === value);
    }
    if (!matchingVariant) {
      matchingVariant = resolveVariantForSize(productData, value)
    }
    if (!matchingVariant) return
    const variantId = matchingVariant.id
    const productSlider = document.getElementById('Product-Slider')
    const sectionId = productSlider.getAttribute('data-section-id')
    const form = document.getElementById(`product-form-${sectionId}`)

    // Update Variant ID for Add to Cart
    form.querySelector('input[name="id"]').value = variantId

    // Update URL with Variant ID Parameter
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has('variant')) {
      currentUrl.searchParams.set('variant', variantId);
    } else {
      currentUrl.searchParams.append('variant', variantId);
    }

    const currentParams = currentUrl.search; // Preserve any existing query parameters
    const currentPath = currentUrl.pathname; // Get the current path

    // Check if the current path includes '/products/'
    let newPath;
    if (currentPath.includes('/products/')) {
      newPath = currentPath.replace(/\/products\/[^/]+/, `/products/${productData.handle}`);
    }
    const newUrl = `${newPath}${currentParams}`;
    window.history.replaceState({}, '', newUrl);

  }

  function createNewSlides(productData, sectionId) {
    return productData.media.map((media, index) => {
      const slideDiv = document.createElement('div');
      slideDiv.id = `Slide-${sectionId}-${media.id}`;
      slideDiv.className = 'product-images__slide is-active';
      slideDiv.setAttribute('data-media-id', `${sectionId}-${media.id}`);

      const mediaDiv = document.createElement('div');
      mediaDiv.className = 'product-single__media product-single__media-image aspect-ratio aspect-ratio--adapt';
      mediaDiv.id = `Media-Thumbnails-${sectionId}-${media.id}`;
      mediaDiv.style.setProperty('--padding-bottom', '129.62962962962962%');

      const zoomLink = document.createElement('a')
      zoomLink.href = media.src
      zoomLink.className = 'product-single__media-zoom'
      zoomLink.setAttribute('data-msrc', media.src + '&width=20')
      zoomLink.setAttribute('data-h', media.height)
      zoomLink.setAttribute('data-w', media.width)
      zoomLink.setAttribute('target', '_blank')
      zoomLink.setAttribute('tab-index', '-1')
      zoomLink.title = 'Zoom'
      zoomLink.setAttribute('data-index', index)

      zoomLink.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.125 3.75H16.25V6.875" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M11.875 8.125L16.25 3.75" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M6.875 16.25H3.75V13.125" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8.125 11.875L3.75 16.25" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M16.25 13.125V16.25H13.125" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M11.875 11.875L16.25 16.25" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M3.75 6.875V3.75H6.875" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8.125 8.125L3.75 3.75" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
      `

      const img = document.createElement('img');
      img.className = 'lazyautosizes';
      img.width = media.width;
      img.height = media.height;
      img.setAttribute('data-sizes', 'auto');
      img.src = media.src;
      img.setAttribute('data-srcset', `${media.src} 345w,${media.src} 610w,${media.src} 1220w`);
      img.setAttribute('fetchpriority', 'auto');
      img.alt = media.alt;
      img.sizes = '610px';
      img.srcset = `${media.src} 345w,${media.src} 610w,${media.src} 1220w`

      const noscript = document.createElement('noscript');
      const noscriptImg = document.createElement('img');
      noscriptImg.width = media.width;
      noscriptImg.height = media.height;
      noscriptImg.sizes = 'auto';
      noscriptImg.src = media.src;
      noscriptImg.srcset = `${media.src} 345w,${media.src} 610w,${media.src} 1220w`;
      noscriptImg.alt = media.alt;
      noscriptImg.setAttribute('fetchpriority', 'auto');
      noscriptImg.setAttribute('loading', 'lazy');

      noscript.appendChild(noscriptImg);

      mediaDiv.appendChild(zoomLink);
      mediaDiv.appendChild(img);
      mediaDiv.appendChild(noscript);

      slideDiv.appendChild(mediaDiv);
      return slideDiv;
    });
  }

  function addZoomToImages() {
    // Add Zoom
    const links = document.querySelectorAll('.product-single__media-zoom');
    const pswpElement = document.querySelectorAll('.pswp')[0];
    const pswpOptions = {
      maxSpreadZoom: 2,
      loop: false,
      allowPanToNext: false,
      closeOnScroll: false,
      showHideOpacity: false,
      arrowKeys: true,
      history: false,
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: true,
      arrowEl: true,
      preloaderEl: true
    };

    links.forEach((link => {
      link.addEventListener('click', (e) => zoomClick(e, link));
    }));

    function buildItems() {
      const slider = document.getElementById('Product-Slider')
      const activeImages = Array.from(slider.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));
  
      return activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);
  
        let activelink = item.querySelector('.product-single__media-zoom');
  
        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }

    function zoomClick(e, link) {
      const items = buildItems()
      pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }

  function createNewThumbnail(media, sectionId) {
    const thumbDiv = document.createElement('div');
    thumbDiv.id = `Thumb-${sectionId}-${media.id}`;
    thumbDiv.className = 'product-thumbnail is-active product-images__slide-item--variant';

    const img = document.createElement('img');
    img.className = 'lazyautosizes';
    img.width = media.width;
    img.height = media.height;
    img.setAttribute('data-sizes', 'auto');
    img.src = media.src;
    img.setAttribute('data-srcset', `${media.src} 160w`);
    img.setAttribute('fetchpriority', 'auto');
    img.alt = media.alt;
    img.sizes = '80px';
    img.srcset = `${media.src} 160w`;

    const noscript = document.createElement('noscript');
    const noscriptImg = document.createElement('img');
    noscriptImg.width = media.width;
    noscriptImg.height = media.height;
    noscriptImg.sizes = 'auto';
    noscriptImg.src = media.src;
    noscriptImg.srcset = `${media.src} 160w`;
    noscriptImg.alt = media.alt;
    noscriptImg.setAttribute('fetchpriority', 'auto');
    noscriptImg.setAttribute('loading', 'lazy');

    noscript.appendChild(noscriptImg);
    thumbDiv.appendChild(img);
    thumbDiv.appendChild(noscript);

    return thumbDiv;
  }

  function updateThumbnails(productData, sectionId) {
    const thumbnailContainer = document.getElementById('Product-Thumbnails')
    thumbnailContainer.innerHTML = ''

    productData.media.forEach((media) => {
      const thumbnail = createNewThumbnail(media, sectionId);
      thumbnailContainer.appendChild(thumbnail);
    });

    attachThumbnailEvents(thumbnailContainer);
  }

  function attachThumbnailEvents(thumbnailContainer) {
    const thumbnails = thumbnailContainer.querySelectorAll('.product-thumbnail')
    const productSlider = document.getElementById('Product-Slider')
    productSlider.reInit();
    if (thumbnails.length > 0) {
      const firstThumbnail = thumbnails[0];
      firstThumbnail.classList.add('is-initial-selected');
    }
  }

  function createNewSizeSwatches(productData, storedSizeIndex, storedSizeValue, resolvedSizeValue) {
    const productSlider = document.getElementById('Product-Slider')
    const sectionId = productSlider.getAttribute('data-section-id')
    const fieldset = findSizeFieldset(document)
    if (!fieldset) return null
    const name = productData.options[1].name
    const position = productData.options[1].position
    const values = productData.options[1].values
    const productHandle = productData.handle
    const formLabel = fieldset.querySelector('.form__label')
    // Save the complete form label HTML (includes size chart modal if present)
    const formLabelHTML = formLabel ? formLabel.outerHTML : `<div class="form__label"> ${name} </div>`

    // Create inputs
    let selectedSize = null;
    withFocusPreserved(fieldset, () => {
      // Clear old sizes
      fieldset.innerHTML = formLabelHTML

      values.forEach((value, index) => {
        const matchingVariant = productData.variants.find(variant => variant.option2 === value); // Find matching variant by option value

        // Create the size swatch input element
        const sizeSwatch = document.createElement('input');
        sizeSwatch.type = 'radio';
        sizeSwatch.id = `${sectionId}-${position}-${index}`;
        sizeSwatch.name = name;
        sizeSwatch.value = value;
        sizeSwatch.setAttribute('form', `product-form-${sectionId}`);
        sizeSwatch.setAttribute('data-product-handle', productHandle);
        sizeSwatch.setAttribute('data-index', index);
        // Sibling colors do not all carry the same size run, so the stored size value
        // is authoritative; the stored index is only a fallback.
        const isSelected = storedSizeValue ? value === storedSizeValue : parseInt(storedSizeIndex) === index
        if (isSelected) {
          sizeSwatch.setAttribute('checked', '')
          sizeSwatch.checked = true
          selectedSize = value
        }

        // Create label for input
        const sizeLabel = document.createElement('label')
        sizeLabel.setAttribute('for', `${sectionId}-${position}-${index}`)
        if (!matchingVariant.available) {
          sizeLabel.className = 'disabled-label'
        }
      
        // Create label span
        const labelSpan = document.createElement('span')
        labelSpan.innerText = value

        // Append elements
        fieldset.append(sizeSwatch)
        sizeLabel.append(labelSpan)
        fieldset.append(sizeLabel)
      })

      // Nothing matched: fall back to the variant the rest of the page resolved to,
      // so the checked radio, the price and the hidden variant id describe one variant.
      if (!selectedSize) {
        selectedSize = checkFallbackSizeSwatch(fieldset, resolvedSizeValue, storedSizeIndex)
      }
    })

    // Update the size label text while preserving any child elements (like modal links)
    const updatedFormLabel = fieldset.querySelector('.form__label')
    if (updatedFormLabel) {
      // Check if there's a .form__label__value span (like in color swatches)
      const labelValueSpan = updatedFormLabel.querySelector('.form__label__value');
      if (labelValueSpan && selectedSize) {
        labelValueSpan.innerText = ` ${selectedSize}`;
      } else if (!labelValueSpan && selectedSize) {
        // Otherwise, update just the text node while preserving child elements
        const textNode = Array.from(updatedFormLabel.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        if (textNode) {
          textNode.textContent = `${name}: ${selectedSize}`;
        } else {
          // If no text node exists, prepend one
          updatedFormLabel.prepend(`${name}: ${selectedSize}`)
        }
      }
    }
  }

  // The size option is not always called "Size" - on a translated storefront the
  // fieldset handle follows the translated option name - so fall back to the second
  // option position, which is where the size run always lives.
  function findSizeFieldset(root) {
    if (!root) return null
    return root.querySelector('fieldset[data-handle="size"]')
      || root.querySelector('fieldset[data-index="option2"]:not([data-colorswatches="true"])')
  }

  // Check the radio matching the variant the page resolved to and return its value.
  function checkFallbackSizeSwatch(fieldset, resolvedSizeValue, storedSizeIndex) {
    const swatches = fieldset.querySelectorAll('input[type="radio"]')
    let fallback = null
    for (const swatch of swatches) {
      if (resolvedSizeValue && swatch.value === resolvedSizeValue) {
        fallback = swatch
        break
      }
      if (!fallback && parseInt(storedSizeIndex) === parseInt(swatch.dataset.index)) {
        fallback = swatch
      }
    }
    if (!fallback) return null
    fallback.setAttribute('checked', '')
    fallback.checked = true
    return fallback.value
  }

  function buildStickyPriceMarkup(productData, matchingVariant, sectionId) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = buildCompletePriceMarkup(productData, matchingVariant, sectionId)
    const priceEl = wrapper.querySelector('.price')
    if (!priceEl) return ''

    // The sticky bar renders its price without badges
    const badges = priceEl.querySelector('.badges')
    if (badges) {
      badges.remove()
    }
    return priceEl.outerHTML
  }

  function createNewStickySizeSwatches(fieldset, productData, storedSizeIndex, sectionId, storedSizeValue, resolvedSizeValue) {
    const sizeOption = productData.options[1]
    if (!sizeOption) return null

    const name = sizeOption.name
    const position = sizeOption.position
    const values = sizeOption.values
    const productHandle = productData.handle
    const formLabel = fieldset.querySelector('.form__label')
    // Save the complete form label HTML (includes size chart modal if present)
    const formLabelHTML = formLabel ? formLabel.outerHTML : `<div class="form__label"> ${name} </div>`

    let selectedSize = null
    withFocusPreserved(fieldset, () => {
      // Clear old sizes
      fieldset.innerHTML = formLabelHTML

      values.forEach((value, index) => {
        const matchingVariant = productData.variants.find(variant => variant.option2 === value)

        const sizeSwatch = document.createElement('input')
        sizeSwatch.type = 'radio'
        sizeSwatch.id = `${sectionId}-${position}-${index}--sticky`
        sizeSwatch.name = `${name}--sticky`
        sizeSwatch.value = value
        sizeSwatch.setAttribute('form', `product-form-${sectionId}`)
        sizeSwatch.setAttribute('data-product-handle', productHandle)
        sizeSwatch.setAttribute('data-index', index)
        // Sibling colors do not all carry the same size run, so the stored size value
        // is authoritative; the stored index is only a fallback.
        const isSelected = storedSizeValue ? value === storedSizeValue : parseInt(storedSizeIndex) === index
        if (isSelected) {
          sizeSwatch.setAttribute('checked', '')
          sizeSwatch.checked = true
          selectedSize = value
        }

        const sizeLabel = document.createElement('label')
        sizeLabel.setAttribute('for', sizeSwatch.id)
        if (!matchingVariant || !matchingVariant.available) {
          sizeLabel.className = 'disabled-label'
        }

        const labelSpan = document.createElement('span')
        labelSpan.innerText = value

        fieldset.append(sizeSwatch)
        sizeLabel.append(labelSpan)
        fieldset.append(sizeLabel)
      })

      // Nothing matched: fall back to the variant the sticky bar resolved to, so the
      // checked radio, the price and the hidden variant id describe one variant.
      if (!selectedSize) {
        selectedSize = checkFallbackSizeSwatch(fieldset, resolvedSizeValue, storedSizeIndex)
      }

      const updatedFormLabel = fieldset.querySelector('.form__label')
      if (updatedFormLabel) {
        const labelValueSpan = updatedFormLabel.querySelector('.form__label__value')
        if (labelValueSpan && selectedSize) {
          labelValueSpan.innerText = ` ${selectedSize}`
        }
      }
    })

    return selectedSize
  }

  function updateStickyAddToCart(productData, storedSizeValue, storedSizeIndex, sectionId) {
    const sticky = document.querySelector('product-add-to-cart-sticky')
    if (!sticky) return

    const matchingVariant = resolveVariantForSize(productData, storedSizeValue)
    if (!matchingVariant) return

    // Image
    const imageContainer = sticky.querySelector(`#product-image-${sectionId}--sticky`)
    const firstMedia = productData.media && productData.media[0]
    // The first media is not always an image - video, external_video and model entries
    // carry no src, only a preview_image. Leave the existing thumbnail alone rather
    // than throwing part way through the sticky bar update.
    const mediaSrc = firstMedia && (firstMedia.src || (firstMedia.preview_image && firstMedia.preview_image.src))
    if (imageContainer && mediaSrc) {
      const separator = mediaSrc.indexOf('?') === -1 ? '?' : '&'
      const image = document.createElement('img')
      image.className = 'no-blur'
      if (firstMedia.width) image.width = firstMedia.width
      if (firstMedia.height) image.height = firstMedia.height
      image.src = `${mediaSrc}${separator}width=160`
      image.alt = firstMedia.alt || productData.title || ''
      image.loading = 'lazy'
      imageContainer.innerHTML = ''
      imageContainer.appendChild(image)
    }

    // Title
    const stickyTitle = sticky.querySelector('.product-add-to-cart-sticky--title')
    if (stickyTitle) {
      stickyTitle.innerText = productData.title
    }

    // Price
    const stickyPrice = sticky.querySelector(`#price-${sectionId}--sticky`)
    if (stickyPrice) {
      stickyPrice.innerHTML = buildStickyPriceMarkup(productData, matchingVariant, sectionId)
      stickyPrice.classList.remove('visibility-hidden')
    }

    // Size options
    const stickyFieldset = findSizeFieldset(sticky)
    if (stickyFieldset) {
      createNewStickySizeSwatches(stickyFieldset, productData, storedSizeIndex, sectionId, storedSizeValue, matchingVariant.option2)
    }

    // Point the sticky picker at the product now on screen
    const stickySelects = sticky.querySelector('pdp-variant-selects')
    if (stickySelects) {
      stickySelects.setAttribute('data-url', `${localeRoot()}products/${productData.handle}`)
      // Defensive only: nothing reads these today, but keep the inline variants JSON
      // and the cached copy in step with the product now on screen for anything that
      // may read them later.
      const stickyVariantJSON = stickySelects.querySelector('[type="application/json"]')
      if (stickyVariantJSON) {
        stickyVariantJSON.textContent = JSON.stringify(productData.variants)
      }
      stickySelects.variantData = productData.variants
    }

    // Add to cart button state
    const stickyButton = sticky.querySelector('#AddToCartSticky')
    if (stickyButton) {
      const stickyButtonText = stickyButton.querySelector('span.single-add-to-cart-button--text')
      if (!matchingVariant.available) {
        stickyButton.setAttribute('disabled', 'disabled')
        stickyButton.classList.add('sold-out')
        if (stickyButtonText) {
          stickyButtonText.innerText = window.theme.variantStrings.soldOut
        }
      } else {
        stickyButton.removeAttribute('disabled')
        stickyButton.classList.remove('sold-out')
        if (stickyButtonText) {
          // Keep the pre-order wording the sticky snippet rendered, as product.js does
          const stickyForm = stickyButton.closest('product-form')
          const productTemplate = stickyForm ? stickyForm.getAttribute('template') : null
          stickyButtonText.innerText = productTemplate && productTemplate.includes('pre-order')
            ? window.theme.variantStrings.preOrder
            : window.theme.variantStrings.addToCart
        }
      }
    }
  }

  // Two swaps in quick succession each start a render; the second shopper choice is
  // the one on screen, so a first render that comes back last must not be applied.
  let installmentRequestToken = 0
  // The product handle and variant price the estimate on screen was last rendered for.
  // Shop Pay quotes a price, not a variant, so a swap that lands on the same product at
  // the same price leaves the rendered terms already correct.
  let lastInstallmentKey = null
  // The variant the shopper is actually on, and the product it belongs to, recorded on
  // every pass including the ones that return early. A render started for an earlier
  // variant can still be in flight when a same-price size pick repoints the form, so the
  // markup that lands has to be corrected to this variant before it is trusted.
  let lastInstallmentVariantId = null
  let lastInstallmentHandle = null

  // Fetch one render of a product section and hand back a detached container holding
  // its markup, so a single request can serve every consumer on the swap path.
  function fetchProductSection(handle, sectionId, variantId) {
    const variantParam = variantId ? `&variant=${variantId}` : ''
    return fetch(`${localeRoot()}products/${handle}?sections=${sectionId}${variantParam}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch section: ${response.statusText}`)
        }
        return response.json()
      })
      .then(data => {
        let sectionHTML = data[sectionId]
        if (!sectionHTML && Object.keys(data).length > 0) {
          sectionHTML = data[Object.keys(data)[0]]
        }
        if (!sectionHTML) return null

        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = sectionHTML
        return tempDiv
      })
  }

  // A destination product whose price falls outside installment eligibility renders no
  // terms at all, and a failed render tells us nothing about the new price - either way
  // the terms still on screen quote the product the shopper has left, so drop them.
  function clearPaymentTerms(scope) {
    const staleTerms = scope.querySelector('#product-form-installment shopify-payment-terms')
    if (staleTerms) {
      staleTerms.remove()
    }
  }

  function applyInstallmentEstimate(tempDiv, scope, handle) {
    const newInstallmentForm = tempDiv.querySelector('#product-form-installment')
    const currentInstallmentForm = scope.querySelector('#product-form-installment')
    if (!currentInstallmentForm) return
    if (!newInstallmentForm || !newInstallmentForm.querySelector('shopify-payment-terms')) {
      clearPaymentTerms(scope)
      return
    }

    currentInstallmentForm.replaceWith(newInstallmentForm)
    repointInstallmentForm(newInstallmentForm, handle)
  }

  // The render carries the variant it was requested for. A same-price size pick inside
  // the same product takes the early return, so it never starts a render of its own and
  // never invalidates this one - the form that just landed would quote the size the
  // shopper has moved off. Point it back at the variant on screen. Only ever within the
  // product this render belongs to, so a late render of another product cannot be
  // relabelled with a variant it does not own.
  function repointInstallmentForm(installmentForm, handle) {
    if (!lastInstallmentVariantId) return
    if (!handle || handle !== lastInstallmentHandle) return

    const variantInput = installmentForm.querySelector('input[name="id"]')
    if (variantInput && String(variantInput.value) !== String(lastInstallmentVariantId)) {
      variantInput.value = lastInstallmentVariantId
      // product.js announces the same input the same way when the variant changes.
      variantInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
    const paymentTerms = installmentForm.querySelector('shopify-payment-terms')
    if (paymentTerms && paymentTerms.getAttribute('variant-id') !== String(lastInstallmentVariantId)) {
      paymentTerms.setAttribute('variant-id', String(lastInstallmentVariantId))
    }
  }

  // Shopify renders the installment estimate, and the tooltip behind it, from the
  // variant referenced by the nested installment form - a form the swap otherwise
  // leaves pointing at the variant the page loaded with, so the estimate keeps
  // quoting the price the shopper arrived on. Point the nested form at the variant
  // now on screen straight away, then swap in the destination product's own server
  // rendering of that form so the estimate and the tooltip are both calculated
  // against the price in the main buy area. No page reload either way.
  function updateInstallmentEstimate(productData, matchingVariant, sectionId, sharedAccordionSectionId) {
    if (!matchingVariant || !sectionId) return

    // Recorded before any early return below: a render already in flight reads these to
    // land on the variant the shopper ended up on rather than the one it was started for.
    lastInstallmentVariantId = matchingVariant.id
    lastInstallmentHandle = productData.handle

    // #product-form-installment is not section scoped, so stay inside the section being
    // updated. On a product page that is the main buy area; quick view carries its own
    // markup, and the section id here comes from the slider the swap is driving.
    const scope = document.getElementById(`shopify-section-${sectionId}`) || document
    const installmentForm = scope.querySelector('#product-form-installment')
    if (!installmentForm) return

    // Read what is on screen before the form is repointed, so the first swap of the
    // page knows what the server already rendered.
    if (lastInstallmentKey === null) {
      lastInstallmentKey = renderedInstallmentKey(installmentForm, productData)
    }
    const installmentKey = `${productData.handle}:${matchingVariant.price}`
    const estimateUnchanged = lastInstallmentKey === installmentKey

    const variantInput = installmentForm.querySelector('input[name="id"]')
    if (variantInput) {
      variantInput.value = matchingVariant.id
      // product.js announces the same input the same way when the variant changes.
      variantInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
    const paymentTerms = installmentForm.querySelector('shopify-payment-terms')
    if (paymentTerms) {
      paymentTerms.setAttribute('variant-id', String(matchingVariant.id))
    }

    // A plain size pick inside the same product at the same price quotes the same
    // instalments. Tearing the terms out and re-inserting them a round trip later
    // would only flash and shift the buy area, so leave the rendered markup alone.
    if (estimateUnchanged) return false

    // Between here and the render landing the terms on screen still quote the previous
    // variant's price. No estimate beats a wrong one; applyInstallmentEstimate installs
    // the authoritative markup below.
    clearPaymentTerms(scope)
    lastInstallmentKey = installmentKey

    // The swap can cross to a different product, so the authoritative markup has to
    // come from a render of the destination product at the resolved variant.
    const token = ++installmentRequestToken
    fetchProductSection(productData.handle, sectionId, matchingVariant.id)
      .then(tempDiv => {
        // An earlier swap that resolved late would install its estimate under the
        // title and price of the product the shopper is actually looking at.
        if (token !== installmentRequestToken) return
        // Nothing authoritative landed, so the next swap must not trust the key.
        if (!tempDiv) {
          lastInstallmentKey = null
          return
        }

        // The accordions read from the same render when they live in this section. A
        // failure applying them says nothing about the estimate, so keep it contained.
        if (sharedAccordionSectionId) {
          try {
            applyProductAccordions(tempDiv, sharedAccordionSectionId)
          } catch (error) {
            console.error('There was a problem updating the product accordions:', error)
          }
        }

        applyInstallmentEstimate(tempDiv, scope, productData.handle)
      })
      .catch(error => {
        console.error('There was a problem updating the installment estimate:', error)
        if (token !== installmentRequestToken) return
        // Nothing authoritative landed, so the next swap must not trust the key.
        lastInstallmentKey = null
        clearPaymentTerms(scope)
      })

    return true
  }

  // The estimate the server rendered with the page, expressed the same way as the key
  // the swap keeps. Variant ids are unique across products, so an id the destination
  // product does not own means the page was rendered for a different product.
  function renderedInstallmentKey(installmentForm, productData) {
    if (!installmentForm.querySelector('shopify-payment-terms')) return null
    const variantInput = installmentForm.querySelector('input[name="id"]')
    const renderedId = variantInput && variantInput.value
    if (!renderedId) return null
    const renderedVariant = productData.variants.find(variant => String(variant.id) === String(renderedId))
    if (!renderedVariant) return null
    return `${productData.handle}:${renderedVariant.price}`
  }

  // Find the section ID dynamically from the page
  // (accordion ID format: Accordion-{blockId}-{sectionId})
  function findAccordionSectionId() {
    const fitAccordion = document.querySelector('[id^="Accordion-collapsible_tab_PbMWpK-"]');

    // Gift cards and other products without accordions - nothing to update
    if (!fitAccordion) return null;

    return fitAccordion.id.split('-').slice(2).join('-'); // Get everything after the second dash
  }

  function updateProductAccordions(productData) {
    const sectionId = findAccordionSectionId();
    if (!sectionId) return;

    // Use Section Rendering API to fetch updated accordion content
    fetchProductSection(productData.handle, sectionId)
      .then(tempDiv => {
        if (!tempDiv) return;
        applyProductAccordions(tempDiv, sectionId);
      })
      .catch(error => {
        console.error('Error updating product accordions:', error);
      });
  }

  // Apply an already parsed render of the product section to the accordions on screen.
  function applyProductAccordions(tempDiv, sectionId) {

    // Update Materials & Care accordion (collapsible_tab_b9gtFz)
    const materialsBlockId = 'collapsible_tab_b9gtFz';
    const materialsAccordionId = `Accordion-${materialsBlockId}-${sectionId}`;
    const newMaterialsContent = tempDiv.querySelector(`#${materialsAccordionId}`);
    const currentMaterialsContent = document.querySelector(`#${materialsAccordionId}`);

    if (newMaterialsContent && currentMaterialsContent) {
      currentMaterialsContent.innerHTML = newMaterialsContent.innerHTML;
    }

    // Update Size Chart accordion (collapsible_tab_bnbw4G)
    const sizeChartBlockId = 'collapsible_tab_bnbw4G';
    const sizeChartAccordionId = `Accordion-${sizeChartBlockId}-${sectionId}`;
    const newSizeChartContent = tempDiv.querySelector(`#${sizeChartAccordionId}`);
    const currentSizeChartContent = document.querySelector(`#${sizeChartAccordionId}`);

    if (newSizeChartContent && currentSizeChartContent) {
      currentSizeChartContent.innerHTML = newSizeChartContent.innerHTML;
    }

    // Update Fit accordion (collapsible_tab_PbMWpK)
    const fitBlockId = 'collapsible_tab_PbMWpK';
    const fitAccordionId = `Accordion-${fitBlockId}-${sectionId}`;
    const newFitContent = tempDiv.querySelector(`#${fitAccordionId}`);
    const currentFitContent = document.querySelector(`#${fitAccordionId}`);

    if (newFitContent && currentFitContent) {
      currentFitContent.innerHTML = newFitContent.innerHTML;
    } 

    // Handle Fit accordion visibility - hide if empty, show if has content
    const fitCollapsibleRow = document.querySelector(`#Details-${fitBlockId}-${sectionId}`)?.closest('collapsible-row');
    const newFitCollapsibleRow = tempDiv.querySelector(`#Details-${fitBlockId}-${sectionId}`)?.closest('collapsible-row');
    const metafieldContent = newFitCollapsibleRow?.querySelector('.collapsible__content');

    if (fitCollapsibleRow) {
      if (metafieldContent?.innerText.trim() !== '') {
        // New product has fit content - show it
        fitCollapsibleRow.style.display = 'block';
      } else {
        // New product doesn't have fit content - hide it
        fitCollapsibleRow.style.display = 'none';
      }
    }
  }
}